const collapsedClass = 'collapsed';
const expandedClass = 'expanded';
const toggleSelector = '.collapse-toggle';
const targetAttribute = 'data-collapse-toggle';

function toggleExpandCollapse(e){
    const clickedToggle = e.target.closest(toggleSelector);
    if (clickedToggle){
        e.preventDefault();
        let toggleTarget;
        const targetId = clickedToggle.getAttribute(targetAttribute);
        if (targetId){
            toggleTarget = document.getElementById(targetId);
        } else {
            toggleTarget = clickedToggle.nextElementSibling;
        }
        toggleTarget.classList.toggle(collapsedClass);
        toggleTarget.classList.toggle(expandedClass);
    }
}

export default toggleExpandCollapse;